import {Component, OnInit} from '@angular/core';
import {AccountBookingService} from "../../../services/account-booking.service";
import {AlertService} from "../../../services/alert.service";
import {LoaderService} from "../../../services/loader.service";
import {Router} from "@angular/router";
import {Subject} from "rxjs/Rx";
import * as $ from 'jquery';
import {PrintService} from "../../../services/print.service";

@Component({
  selector: 'app-account-booking-list',
  templateUrl: './account-booking-list.component.html',
  styleUrls: ['./account-booking-list.component.css']
})

export class AccountBookingListComponent implements OnInit {
  private loading = false;
  private accountBookingList;
  dtTrigger:Subject<any> = new Subject();
  dtOptions:any = {};
  authWindow = null;

  constructor(private accountBookingService:AccountBookingService,
              private alertService:AlertService,
              private printService:PrintService,
              private router:Router,
              private loaderService:LoaderService) {
  }

  ngOnInit() {
    this.loaderService.loading(true);
    this.dtOptions = {
      select: true,
      buttons: [
        'columnsToggle',
        'colvis',
        'copy',
        'print',
        'excel',
        {
          text: 'Some button',
          key: '1',
          action: function (e, dt, node, config) {
            alert('Button activated');
          }
        }
      ]
    };

    this.accountBookingService
      .list()
      .subscribe(
        data => {
          this.accountBookingList = data;
          this.initDataTable()
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.loaderService.loading(false);
        });
  }

  initDataTable() {
    $(document).ready(()=> {
      var table:any = $('table');
      table.dataTable();
      this.loaderService.loading(false);
    })
  }

  goToAccountDetails(id:number) {
    this.router.navigate(['/accounts', id]);
  }

  print() {
    this.printService.generate_pdf_file()
  }
}




// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/account-booking/account-booking-list/account-booking-list.component.ts